module.exports = __webpack_public_path__ + "static/media/AppStore_English.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AppStore_English.svg
// module id = 303
// module chunks = 21